const FI = {
  associationIncorporated: [
    "osuuskunta (Osk) / andelslag (Anl)"
  ],
  partnershipIncorporated: [
    "kommandiittiyhtiö / kommanditbolag (Ky/kb)"
  ],
  partnershipUnincorporated: [
    "avoin yhtiö / öppet bolag"
  ]
};
export {
  FI as default
};
